import {request} from "../../../res/rest/restRequest";
import {api} from "../../../res/rest/api";
import HttpClient from "../../services/http/HttpClient";
import {env} from "../../../res/config/env";

const updateOrderRequest = async (session, orderID, toChange) => {
    const req = request.model(api.MODEL.C_ORDER)
        .id(orderID)
        .buildRequest();
    const resp = await HttpClient.client.put(env.API_URL + req, toChange, api.auth(session));
    return resp.data;
}

export default updateOrderRequest;